module.exports = fox._r("images/christmass/gift-174.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/christmass/gift-174.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/christmass/gift-174.png
// module id = 398
// module chunks = 4